import { ResourceContextProvider, TextField, TextInput } from "react-admin";

import {
  DataKind,
  getRegionalResourceName,
  Region,
  Resource,
  ResourceRegional,
} from "../../types";
import {
  CustomDateTimeField,
  CustomList,
  CustomReferenceField,
  JsonField,
} from "../custom";

const auditLogConfigVariablesTitle = "Config Variables Audit Log";

const auditLogConfigVariablesFilters = [
  <TextInput label="Entity Id" source="config_variable_id_eq" alwaysOn />,
  <TextInput label="Admin User Id" source="admin_user_id_eq" alwaysOn />,
];

function AuditLogsConfigVariables(props: { region: Region }) {
  return (
    <ResourceContextProvider
      value={getRegionalResourceName(
        props.region,
        ResourceRegional.AuditLogConfigVariables,
      )}
    >
      <CustomList
        checkPermissionFor={DataKind.ConfigVariable}
        customTitle={auditLogConfigVariablesTitle}
        defaultSort={{ field: "created_at", order: "DESC" }}
        displayCreate={false}
        disableRowClick={true}
        filters={auditLogConfigVariablesFilters}
      >
        <TextField label="Entity Id" source="config_variable_id" />
        <CustomReferenceField
          label="Admin User"
          source="admin_user_id"
          reference={Resource.AdminUser}
          sortable={false}
        >
          <TextField source="email" />
        </CustomReferenceField>
        <CustomDateTimeField label="Event Timestamp" source="created_at" />
        <TextField label="Event Action" source="event" sortable={false} />
        <JsonField
          label="Event Attributes"
          source="event_attributes"
          sortable={false}
        />
        <JsonField label="Entity" source="entity" sortable={false} />
      </CustomList>
    </ResourceContextProvider>
  );
}

export default AuditLogsConfigVariables;
